/**
 * @generated SignedSource<<476d6de5c536b981989b6f864b901135>>
 * @relayHash 26c3597ce5833f65779fda9f531078f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6650aa4250eefbf326964ca54896adae71faa97e9fed32b8bb553056747cc913

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CalendarContentQuery } from './CalendarContentQuery.graphql';

const node: PreloadableConcreteRequest<CalendarContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6650aa4250eefbf326964ca54896adae71faa97e9fed32b8bb553056747cc913",
    "metadata": {},
    "name": "CalendarContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
